import React from "react";
import DownloadsModule from "modules/downloads/downloads.module";

const DownloadsPage = () => <DownloadsModule />;

export default DownloadsPage;
